import { useEffect, useRef, useState } from "react";
import { T } from "@/components/T";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Handles the custom Google OAuth return: {origin}/auth/google?code=...&state=...
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { completeGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const savedState = sessionStorage.getItem("g_oauth_state");
    sessionStorage.removeItem("g_oauth_state");
    if (params.get("error") || !code) {
      setError("Sign-in was cancelled. Please try again.");
      return;
    }
    if (!state || state !== savedState) {
      setError("Sign-in could not be verified. Please try again.");
      return;
    }
    const redirectUri = window.location.origin + "/auth/google";
    completeGoogle(code, redirectUri)
      .then((u) => {
        navigate(u?.role === "admin" ? "/admin" : "/account", { replace: true });
      })
      .catch(() => setError("Sign-in failed. Please try again."));
  }, [completeGoogle, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-parchment px-5 text-center">
      <div>
        <p className="font-deva text-4xl text-saffron">ॐ</p>
        <p className="mt-4 text-ink-2">{error || "Signing you in…"}</p>
        {error && <a href="/login" className="mt-4 inline-block text-saffron link-underline"><T>Back to sign in</T></a>}
      </div>
    </div>
  );
}
